import { LazyAction, LazyModule } from 'owa-bundling';

export { default as getStore } from './store/store';

// NOTE: these non-lazy actions are for subscription purposes only; do not invoke
export { closeItemPeek } from './actions/closeItemPeek';
export { showItemPeek } from './actions/showItemPeek';
export { hideItemPeek } from './actions/hideItemPeek';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarPeek"*/ './lazyIndex')
);

export const openItemPeek = new LazyAction(lazyModule, m => m.openItemPeek);
export const openItemPeekToRespond = new LazyAction(lazyModule, m => m.openItemPeekToRespond);
export const openItemPeekToCancel = new LazyAction(lazyModule, m => m.openItemPeekToCancel);
